import { useLocation, useMatch } from 'react-router-dom';
import { INTERVIEW_SESSION_PATH, ROOM_PATH } from '../constants';

export function useIsLiveInterviewRoomRoute() {
  const match = useMatch(`${INTERVIEW_SESSION_PATH}/:interviewId/${ROOM_PATH}/:roomName`);
  return !!match;
}
